export const route = {
  index: 'index',
  spotifySignIn: 'spotifySignIn',
  hostRegister: 'hostRegister',
  hostError: 'hostError',
  gameCodeRegister: 'gameCodeRegister',
  playerRegister: 'playerRegister',
  game: 'game',
  feedback: 'feedback',
  playlists: 'playlists',
  gameInfo: 'gameInfo',
  notFound: 'notFound',
};
